export const MINICALC_OFFER_CAROUSEL_MOBWEB = 'b2c_txn1226_minicalculator_offer_carousel_mobweb';
export const SHORT_FORM_WEB = 'b2c_txn1366_short_form_web';

/* Группу короткой анкеты считает бэкенд и отдаёт в meta выдачи, поэтому в ab-use за ней не ходим */
export const AB_EXPERIMENT_NAMES = [MINICALC_OFFER_CAROUSEL_MOBWEB] as const;
